import { useEffect, useMemo, useState } from "react";
import ArrowLeftLineIcon from "remixicon-react/ArrowLeftLineIcon";
import { useForm, Controller } from "react-hook-form";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Papa from "papaparse";
import CheckLineIcon from "remixicon-react/CheckLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";
import CardLayout from "../../components/utils/CardLayout";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import {
  isKeyUnique,
  validateIMEI,
  validateSNo,
  validatePin,
  selectCharacters,
  twoDigitDecimal,
} from "../../helpers/commonFunction";
import activationRequestActions from "../../redux/activationRequest/actions";
import "./ActivationRequest.css";
import Alert from "../../components/utils/Alert";
import planAction from "../../redux/plan/actions";
import shortCodeAction from "../../redux/shortCodeData/actions";

const {
  addBulkActivation,
  resetValidateMessage,
  getDealerPostFixEmail,
  getPrepaidIqAddresses,
  validateSerialNumber,
  checkImeiNumber,
} = activationRequestActions;
const BASE_URL = process.env.REACT_APP_SITE_BASE_URL;

const { getPlan } = planAction;
const { getSimType } = shortCodeAction;

const BulkActivationForm = ({ back, searchData }) => {
  const dispatch = useDispatch();
  const { networkResult } = useSelector((state) => state.network);
  const { planResult } = useSelector((state) => state.plan);
  const { tokenData } = useSelector((state) => state.auth);
  const { shortCodeSimType } = useSelector((state) => state.shortCode);
  const {
    planAddonResult,
    addBulkActivationMessage,
    addBulkActivationError,
    addBulkActivationLoading,
    getPrepaidIqAddressesData,
    validateSerialNumberData,
    validateSerialNumberLoading,
    checkImeiNumberData,
  } = useSelector((state) => state.activationRequest);
  const { addonResult } = useSelector((state) => state.addonService);
  const [csvError, setCsvError] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [planAddonResultData, setPlanAddonResultData] = useState([]);
  const [addOnSelectMultiple, setAddOnSelectMultiple] = useState(false);
  const [planAddonSelectedOption, setPlanAddonSelectedOption] = useState(false);
  const [addonAmount, setAddonAmount] = useState(0);
  const [previewData, setPreviewData] = useState([]);
  const [previewSuccessData, setPreviewSuccessData] = useState([]);
  const [previewFailedData, setPreviewFailedData] = useState([]);
  const [showPreviewType, setShowPreviewType] = useState(2);
  const [activationRequests, setActivationRequests] = useState([]);
  const [previewSuccessCount, setPreviewSuccessCount] = useState(0);
  const [csvLimitError, setCsvLimitError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [networkId, setNetworkId] = useState(0);
  const [prefferAggId, setPrefferAggId] = useState(0);
  const [monthList, setMonthList] = useState([]);
  const [accountBalance, setAccountBalance] = useState(0);
  const [simType, setSimType] = useState(0);
  const [apiCall, setApiCall] = useState(false);
  const [utelError, setUtelError] = useState("");
  const isUTel = networkId == 15;
  const useSerial = simType == 25 || isUTel;


  const ACTIVATION_LIMIT = useMemo(() => {
    if (networkId == 7) {
      return 100;
    } else {
      return 500;
    }
  }, [networkId]);

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => {
        setAccountBalance(data.AccountBalance);
      });
  }, [tokenData]);

  useEffect(() => {
    dispatch(getDealerPostFixEmail());
    dispatch(
      getSimType({
        tableName: "activationrequest",
        fieldName: "SimType",
      }),
    );
  }, []);

  useEffect(() => {
    if (csvLimitError !== null && csvLimitError !== undefined) {
      displayAlert(csvLimitError, "alert-danger");
    }
    if (
      addBulkActivationError !== null &&
      addBulkActivationError !== undefined
    ) {
      displayAlert(addBulkActivationError, "alert-danger");
    }
  }, [csvLimitError, addBulkActivationError]);

  useEffect(() => {
    if (addBulkActivationMessage) {
      back();
      dispatch(resetValidateMessage());
    }
  }, [addBulkActivationMessage]);

  useEffect(() => {
    if (previewData.length > 0) {
      let successPreview = previewData.filter((item) => item.Status == 1);
      let failedPreview = previewData.filter((item) => item.Status == 0);
      setPreviewSuccessData(successPreview);
      setPreviewFailedData(failedPreview);
    }
  }, [previewData]);

  useEffect(() => {
    let selectedNetwork =
      networkResult &&
      networkResult.filter((network) => network.ID == networkId);
    dispatch(getPlan(networkId));
  }, [networkId]);

  useEffect(() => {
    if (planResult.length > 0 && networkResult.length > 0) {
      setSelectedPlan(planResult);
    } else {
      setSelectedPlan([]);
    }
  }, [planResult]);

  useEffect(() => {
    if (validateSerialNumberData.length > 0) {
      setApiCall(false);
      let newDataSource = previewData.map((item) => {
        let count = validateSerialNumberData.filter(
          (item1) => item1.SerialNumber == item.SerialNumber,
        );
        if (count.length > 0) {
          if (count[0].Status === 0) {
            item.Valid = <CloseLineIcon color="#e74c3c" />;
            item.Status = 0;
          }
          item.Reason = count[0].ExistStatus;
        }
        return item;
      });
      setPreviewData(newDataSource);

      let successCount = validateSerialNumberData.filter(
        (item) => item.Status === 1,
      );
      setPreviewSuccessCount(successCount.length);
      // For API Request
      let newDataRequest = activationRequests.map((item) => {
        let count = validateSerialNumberData.filter(
          (item1) => item1.SerialNumber == item.simNumber,
        );
        if (count.length > 0) {
          if (count[0].Status === 0) {
            item.status = 0;
            item.reason = count[0].ExistStatus;
          }
        }
        return item;
      });
      setActivationRequests(newDataRequest);
    }
  }, [validateSerialNumberData]);

  useEffect(() => {
    if (checkImeiNumberData.length > 0) {
      setApiCall(false);
      let newDataSource = previewData.map((item) => {
        let count = checkImeiNumberData.filter(
          (item1) => item1.IMEI == item.IMEI,
        );
        if (count.length > 0) {
          if (count[0].Status === 0) {
            item.Valid = <CloseLineIcon color="#e74c3c" />;
            item.Status = 0;
          }
          item.Reason = count[0].ExistStatus;
        }
        return item;
      });
      setPreviewData(newDataSource);

      let successCount = checkImeiNumberData.filter(
        (item) => item.Status === 1,
      );
      setPreviewSuccessCount(successCount.length);
      // For API Request
      let newDataRequest = activationRequests.map((item) => {
        let count = checkImeiNumberData.filter(
          (item1) => item1.IMEI == item.IMEI,
        );
        if (count.length > 0) {
          if (count[0].Status === 0) {
            item.status = 0;
            item.reason = count[0].ExistStatus;
          }
        }
        return item;
      });
      setActivationRequests(newDataRequest);
    }
  }, [checkImeiNumberData]);

  useEffect(() => {
    if (apiCall && previewData.length > 0) {
      let validData = previewData.filter((item) => item.Status == 1);
      if (validData.length > 0) {
        if (useSerial) {
    let serial_number_array = validData.map((item) => item.SerialNumber);
    dispatch(validateSerialNumber(serial_number_array));
        }
        else if (simType == 26) {
          let imei_number_array = validData.map((item) => item.IMEI);
          dispatch(checkImeiNumber(imei_number_array));
        }
      }
    }
  }, [previewData]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };

  const {
    register: bulkActivationRegister,
    handleSubmit: bulkActivationHandleSubmit,
    formState: { errors: bulkActivationError },
    watch: bulkActivationWatch,
    reset: bulkActivationReset,
    setValue: bulkActivationSetValue,
    setError: bulkActivationSetError,
    clearErrors: bulkActivationClearErrors,
    control: bulkActivationcontrol,
  } = useForm({
    defaultValues: {
      networkID: "",
      planID: "",
      month: "",
      address1: "",
      state: "",
      simType: "",
      threeDigAreaCode: "",
    },
  });

  const selectedAddon = bulkActivationWatch("serviceID");
  const state = bulkActivationWatch("state");
  const simTypeWached = bulkActivationWatch("simType");
  const monthWached = bulkActivationWatch("month");
  const planIDWached = bulkActivationWatch("planID");

  useEffect(() => {
    if (simTypeWached) {
      setSimType(simTypeWached);
    }
  }, [simTypeWached]);

  useEffect(() => {
    if (simType > 0) {
      bulkActivationReset({ uploadedFile: "" });
      setPreviewData([]);
      setActivationRequests([]);
    }
  }, [simType]);

  const stateOptions = useMemo(() => {
    if (getPrepaidIqAddressesData.length > 0) {
      return [...new Set(getPrepaidIqAddressesData.map((item) => item.State))];
    } else {
      return [];
    }
  }, [getPrepaidIqAddressesData]);

  useEffect(() => {
    if (state) {
      let dataOfThisState = getPrepaidIqAddressesData.filter(
        (item) => item.State === state,
      );
      let randomData =
        dataOfThisState[Math.floor(Math.random() * dataOfThisState.length)];
      bulkActivationSetValue("address1", randomData.Address);
      bulkActivationSetValue("address2", randomData.City);
      bulkActivationSetValue("wifiZipCode", randomData.ZIP);
    } else {
      bulkActivationSetValue("address1", "1200 Broadway");
      bulkActivationSetValue("address2", "New York");
      bulkActivationSetValue("wifiZipCode", "10001");
    }
  }, [state]);

  const selectOptions =
    planAddonResultData && planAddonResultData.length > 0
      ? planAddonResultData.map((addon) => ({
          label: addon.ServiceName,
          value: addon.AddonID,
          tmobileAddonId: addon.TMobileAddonID,
        }))
      : [];

  const previewColumns = isUTel
    ? [
        { displayName: "SERIAL NUMBER", key: "SerialNumber" },
        { displayName: "REASON", key: "Reason" },
        { displayName: "VALID", key: "Valid" },
      ]
    : simType == 25
      ? [
          { displayName: "IMEI", key: "IMEI" },
          { displayName: "SERIAL NUMBER", key: "SerialNumber" },
          { displayName: "REASON", key: "Reason" },
          { displayName: "VALID", key: "Valid" },
        ]
      : [
          { displayName: "IMEI", key: "IMEI" },
          { displayName: "REASON", key: "Reason" },
          { displayName: "VALID", key: "Valid" },
        ];

  const downloadSampleFile = () => {
    if (simType != "") {
      if (simType == 25) {
        let url = isUTel
          ? `${BASE_URL}/assets/csv/UTel-bulk-activation-sample-file.csv`
          : `${BASE_URL}/assets/csv/prepaidIQ-bulk-activation-sample-file.csv`;
        let link = document.createElement("a");
        link.href = url;

        link.download = isUTel
          ? "UTel-p-sim-sample-bulk-activation-file.csv"
          : "p-sim-sample-bulk-activation-file.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (simType == 26) {
        let url = isUTel
          ? `${BASE_URL}/assets/csv/UTel-bulk-activation-sample-file.csv`
          : `${BASE_URL}/assets/csv/e-sim-prepaidIQ-bulk-activation-sample-file.csv`;
        let link = document.createElement("a");
        link.href = url;
        link.download = isUTel
          ? "UTel-e-sim-sample-bulk-activation-file.csv"
          : "e-sim-sample-bulk-activation-file.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      bulkActivationSetError("simType", {
        type: "custom",
        message: "Sim type is required !",
      });
    }
  };

  const handleNetwork = (e) => {
    e.preventDefault();
    bulkActivationReset({
      planID: "",
      serviceID: "",
      uploadedFile: "",
      month: "",
      simType: "",
    });
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessData([]);
    setPreviewFailedData([]);
    dispatch(getPlan(e.target.value));
    setNetworkId(e.target.value);
    setSimType("");
  };

  const handleSelectPlan = (e) => {
    bulkActivationReset({
      serviceID: "",
      month: "",
    });
    const singlePlanCategory = ["Connect by T-Mobile", "Mobile Internet Plans"];
    const multiPlanCategory = ["T-Mobile Prepaid"];
    const planId = e.target.value;
    if (planId !== null && planId !== "") {
      const selectedData =
        planResult && planResult.filter((plan) => plan.PlanID == planId);
      const planAddon =
        planAddonResult &&
        planAddonResult.filter((item) => item.PlanID == planId);
      setPlanAddonResultData(planAddon);
      bulkActivationSetValue(
        "aggregatorID",
        selectedData[0].PrefferedAggregator,
      );
      setPrefferAggId(selectedData[0].PrefferedAggregator);

      dispatch(
        getPrepaidIqAddresses({
          prefferedAggregator: selectedData[0].PrefferedAggregator,
        }),
      );

      bulkActivationSetValue("state", "");
      bulkActivationSetValue("address1", "");
      bulkActivationSetValue("city", "");
      bulkActivationSetValue("zipCode", "");

      let mon = selectedData[0].PlanMonth;
      // console.log("mon", mon);
      setMonthList(JSON.parse(mon));

      if (selectedData[0].PlanCategory) {
        if (singlePlanCategory.includes(selectedData[0].PlanCategory)) {
          setAddOnSelectMultiple(false);
        } else if (multiPlanCategory.includes(selectedData[0].PlanCategory)) {
          setAddOnSelectMultiple(true);
        }
        setPlanAddonSelectedOption(true);
      } else {
        setPlanAddonSelectedOption(false);
      }
      // setPlanAmount(selectedData[0].PlanPrice);
      // bulkActivationSetValue('tMobilePlanID', selectedData[0].TMobilePlanID)
    }
  };

  const handleSelectAddon = (e) => {
    let valuesArray = [];
    let tMobileArray = [];

    if (addOnSelectMultiple || true) {
      valuesArray = e.map((item) => item.value);
      tMobileArray = e.map((item) => item.tmobileAddonId);
    } else {
      valuesArray = [e.value];
      tMobileArray = [e.tmobileAddonId];
    }

    bulkActivationSetValue("serviceID", valuesArray);
    bulkActivationSetValue("tMobileAddonID", tMobileArray);

    const resultServiceArray = valuesArray.map((id) => {
      const service = addonResult.find((item) => item.ID === id);
      return service
        ? {
            id,
            ServiceName: service.ServiceName,
            ServicePrice: service.ServicePrice,
          }
        : null;
    });

    const filteredResultServiceArray = resultServiceArray.filter(
      (service) => service !== null,
    );
    const totalServicePrice = filteredResultServiceArray.reduce(
      (total, service) => total + (service.ServicePrice || 0),
      0,
    );

    setAddonAmount(totalServicePrice);
  };

  const handlePreviewTableData = (id) => {
    setShowPreviewType(id);
  };

  const handleFileChange = (e) => {
    bulkActivationClearErrors(["uploadedFile"]);
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessCount(0);
    setActivationRequests([]);
    const fileReader = new FileReader();
    let file = e.target.files[0];

    if (!file) {
      bulkActivationSetError("uploadedFile", {
        type: "custom",
        message: "Csv is required!",
      });
      setCsvError(true);
      return;
    } else {
      let fileNameArr = file.name.split(".");
      let fileExt = fileNameArr[fileNameArr.length - 1];

      if (!["csv"].includes(fileExt.toLowerCase())) {
        bulkActivationSetError("uploadedFile", {
          type: "custom",
          message: "Invalid file type. Only CSV file allowed.",
        });
        setCsvError(true);
        return;
      }
    }

    if (file) {
      fileReader.onload = async ({ target }) => {
        const csvOutput = Papa.parse(target.result, {
          header: true,
          skipEmptyLines: true,
        });
        const parsedData = csvOutput?.data;
        const columns = Object.keys(parsedData[0]);

        if (parsedData.length > ACTIVATION_LIMIT) {
          setCsvLimitError(`Maximum ${ACTIVATION_LIMIT} rows are allowed`);
          setCsvError(true);
          return;
        } else {
          setCsvError(false);
        }
        // ---- UTel: sirf SerialNumber ----
        if (isUTel) {
          const utelRows = parsedData.map((row) => {
            const r = {};
            Object.keys(row).forEach((k) => {
              r[k.replace(/^\uFEFF/, "").trim()] = row[k];
            });
            return r;
          });

          // UTel serial rule: sirf digits, minimum 19
          const isValidUTelSerial = (s) =>
            /^\d{19,}$/.test(String(s || "").trim());

          const utelColumns = Object.keys(utelRows[0]);

          if (!utelColumns.includes("SerialNumber")) {
            bulkActivationSetError("uploadedFile", {
              type: "custom",
              message: "Invalid Csv Selected",
            });
            setCsvError(true);
            return;
          }

          let utelDataSource = utelRows.map((item) => {
            const serial = String(item.SerialNumber || "").trim();
            let error = false;
            let reason = "";
            if (!isValidUTelSerial(serial)) {
              reason = "Serial Number must be minimum 19 digits";
              setCsvError(true);
              error = true;
            }
            if (!error) {
              setPreviewSuccessCount((pre) => pre + 1);
            }
            return {
              IMEI: "",
              SerialNumber: serial,
              Reason: reason,
              Valid: error ? (
                <CloseLineIcon color="#e74c3c" />
              ) : (
                <CheckLineIcon color="#2ecc71" />
              ),
              Status: error ? 0 : 1,
            };
          });

          if (!isKeyUnique(utelDataSource, "SerialNumber")) {
            bulkActivationSetError("uploadedFile", {
              type: "custom",
              message: "Csv contain duplicate sim number",
            });
            return false;
          }

          setPreviewData(utelDataSource);
          setApiCall(true);

          let utelRequestData = utelRows.map((item) => {
            const serial = String(item.SerialNumber || "").trim();
            let error = false;
            let reason = "";
            if (!isValidUTelSerial(serial)) {
              reason = "Serial Number must be minimum 19 digits";
              setCsvError(true);
              error = true;
            }
            return {
              fname: "John",
              lname: "Doe",
              imeiNumber: "",
              simNumber: serial,
              status: error ? 0 : 1,
              reason,
            };
          });
          setActivationRequests(utelRequestData);
          return;
        }
        // ---- UTel end ----

        let specifiedColumn = [];
        if (simType == 25) {
          specifiedColumn.push("IMEI", "SerialNumber");
        } else {
          specifiedColumn.push("IMEI");
        }

        let isValidCsvHeading = specifiedColumn.every((item) =>
          columns.includes(item),
        );

        if (isValidCsvHeading && columns.length === specifiedColumn.length) {
          setCsvError(false);
          let dataSource = parsedData.map((item) => {
            let error = false;
            let reason = "";
            if (!validateIMEI(item.IMEI.slice(0, 15))) {
              reason = "Invalid IMEI";
              setCsvError(true);
              error = true;
            } else if (
              simType == 25 &&
              !validateSNo(
                selectCharacters(item.SerialNumber, networkId),
                networkId,
                simType,
              )
            ) {
              reason = "Invalid Serial Number";
              setCsvError(true);
              error = true;
            }

            if (!error) {
              setPreviewSuccessCount((pre) => pre + 1);
            }

            return {
              IMEI: item.IMEI.slice(0, 15),
              SerialNumber: selectCharacters(item.SerialNumber, networkId),
              Reason: reason,
              Valid: error ? (
                <CloseLineIcon color="#e74c3c" />
              ) : (
                <CheckLineIcon color="#2ecc71" />
              ),
              Status: error ? 0 : 1,
            };
          });

          if (simType == 25 && !isKeyUnique(dataSource, "SerialNumber")) {
            bulkActivationSetError("uploadedFile", {
              type: "custom",
              message: "Csv contain duplicate sim number",
            });
            return false;
          }

          setPreviewData(dataSource);
          setApiCall(true);

          let requestData = parsedData.map((item) => {
            let error = false;
            let reason = "";

            if (!validateIMEI(item.IMEI.slice(0, 15))) {
              reason = "Invalid IMEI";
              setCsvError(true);
              error = true;
            } else if (
              simType == 25 &&
              !validateSNo(
                selectCharacters(item.SerialNumber, networkId),
                networkId,
                simType,
              )
            ) {
              reason = "Invalid Serial Number";
              setCsvError(true);
              error = true;
            }
            return {
              fname: isIspWholeSaleNetwork ? "Robert" : "John",
              lname: isIspWholeSaleNetwork ? "Roy" : "Doe",
              imeiNumber: item.IMEI.slice(0, 15),
              simNumber: selectCharacters(item.SerialNumber, networkId),
              status: error ? 0 : 1,
              reason,
            };
          });
          setActivationRequests(requestData);
        } else {
          bulkActivationSetError("uploadedFile", {
            type: "custom",
            message: "Invalid Csv Selected",
          });
          setCsvError(true);
        }
      };
      fileReader.readAsText(file);
    }
  };

  const handleAddBulkActivation = (data) => {
    data.Pin = data.Pin ? data.Pin : "";
    data.wifiCalling = 1;
    // data.month = "1";
    data.totalRequests = activationRequests.length;

    let approvedRows = activationRequests.filter((item) => item.status == 1);
    data.successRequests = approvedRows.length;

    let failedRows = activationRequests.filter((item) => item.status == 0);
    data.failedRequestData = failedRows;
    data.failedRequest = failedRows.length;
    data.activationRequests = approvedRows;

    data.address2 = data.address2 ? data.address2 : "";
    data.wifiZipCode = data.wifiZipCode ? data.wifiZipCode : "";
    // data.address2 = `${data.address2} ${data.wifiZipCode}`
    data.address2 = `${data.address2}`;
    data.state = isIspWholeSaleNetwork ? "NY" : data.state;
    delete data.uploadedFile;
    // delete data.wifiZipCode;

    // ---- UTel: har serial ke liye unique address ----
    if (isUTel) {
      // same address duplicate na ho, isliye unique list banao
      const uniqueMap = new Map();
      getPrepaidIqAddressesData
        .filter((a) => a.State === data.state)
        .forEach((a) => {
          const key = `${a.Address}|${a.City}|${a.ZIP}`;
          if (!uniqueMap.has(key)) uniqueMap.set(key, a);
        });

      // shuffle (Fisher-Yates)
      const pool = Array.from(uniqueMap.values());
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }

      // har valid row ko ek address, khatam ho gaye to empty
      data.activationRequests = approvedRows.map((row, index) => {
        const addr = pool[index];
        return {
          ...row,
          address1: addr ? addr.Address : "",
          address2: addr ? addr.City : "",
          wifiZipCode: addr ? addr.ZIP : "",
        };

      });
     data.address1 = "";
     data.address2 = "";
     data.wifiZipCode = "";

     const hasEmptyAddress = data.activationRequests.some(
       (row) => !row.address1 || !row.address2 || !row.wifiZipCode,
     );
     if (hasEmptyAddress) {
       setUtelError("Not enough unique addresses available for all SIMs");
       return;
     }
     setUtelError("");
    }
    // ---- UTel end ----

    const selectedPlan = planResult.filter(
      (item) => item.PlanID == data.planID,
    );
    const priceObject = JSON.parse(selectedPlan[0].PlanMonth).filter(
      (item) => item.month == data.month,
    );
    if (isUTel) {
      data.serviceID = [];
    }
    if (!data.serviceID || !data.serviceID.length) {
      data.serviceID = [];
    }

    const selectedAddOn = addonResult.filter((item) =>
      data.serviceID.includes(item.ID),
    );
    let planAddOnTotal = 0;
    selectedAddOn.forEach((item) => {
      planAddOnTotal += item.ServicePrice;
    });

    // const Total = selectedPlan[0].PlanPrice + planAddOnTotal;
    const Total = priceObject[0].price + planAddOnTotal;
    data.purchaseAmount = Total * previewSuccessData.length;

    if (approvedRows.length <= 0) {
      alert("Please upload valid data");
    } else {
      if (accountBalance >= data.purchaseAmount) {
        console.log("data", data);
        console.log("Search data: ", searchData)
        dispatch(addBulkActivation(data, searchData));
      } else {
        alert("insufficient fund");
      }
    }
  };

  // SHOW CALCULATED AMOUNT TABLE
  const estimatedAmountColumn = [
    { displayName: "Total Activation", key: "tActivation" },
    {
      displayName: isUTel
        ? "Per Activation (Plan)"
        : "Per Activation (Plan + Addon)",
      key: "pActivation",
    },
    { displayName: "Total Paid", key: "tPaid" },
  ];

  const estimatedAmountDataSource = useMemo(() => {
    if (monthWached > 0 && planIDWached > 0 && previewSuccessData.length > 0) {
      let tempSelectedAddon = isUTel ? [] : (selectedAddon ?? []);
      const selectedAddOn = addonResult.filter((item) =>
        tempSelectedAddon.includes(item.ID),
      );
      let planAddOnTotal = 0;
      selectedAddOn.forEach((item) => {
        planAddOnTotal += item.ServicePrice;
      });
      const selectedPlan = planResult.filter(
        (item) => item.PlanID == planIDWached,
      );
      const priceObject = JSON.parse(selectedPlan[0].PlanMonth).filter(
        (item) => item.month == monthWached,
      );
      const Total = priceObject[0].price + planAddOnTotal;
      const paidTotal = Total * previewSuccessData.length;

      return [
        {
          tActivation: previewSuccessData.length,
          pActivation: isUTel
            ? `$${twoDigitDecimal(priceObject[0].price)}`
            : `$${twoDigitDecimal(priceObject[0].price)} + $${twoDigitDecimal(planAddOnTotal)}`,
          tPaid: `$${twoDigitDecimal(paidTotal)}`,
        },
      ];
    } else {
      return [
        {
          tActivation: 0,
          pActivation: 0,
          tPaid: 0,
        },
      ];
    }
  }, [monthWached, planIDWached, previewSuccessData, selectedAddon, isUTel]);

  const isIspWholeSaleNetwork = useMemo(() => {
    return networkId == 9;
  }, [networkId]);

  const linkUpMobile = useMemo(() => {
    return networkId == 11;
  }, [networkId]);

  const handleTextareaChange = (val) => {
    bulkActivationClearErrors(["uploadedFile"]);
    setPreviewData([]);
    setActivationRequests([]);
    setPreviewSuccessCount(0);
    setActivationRequests([]);
    const dataArr = val != "" ? val.trim().split("\n") : [];

    if (dataArr.length > 500) {
      bulkActivationSetError("uploadedFile", {
        type: "custom",
        message: "Data contain duplicate SIM number",
      });
      return false;
    }

    if (new Set(dataArr).size !== dataArr.length) {
      bulkActivationSetError("uploadedFile", {
        type: "custom",
        message: "Data contain duplicate SIM number",
      });
      return false;
    }

    let dataSource = dataArr.map((item) => {
      let error = false;
      let reason = "";
      if (
        simType == 25 &&
        !validateSNo(selectCharacters(item, networkId), networkId, simType)
      ) {
        reason = "Invalid Serial Number";
        setCsvError(true);
        error = true;
      }

      if (!error) {
        setPreviewSuccessCount((pre) => pre + 1);
      }

      return {
        IMEI: "",
        SerialNumber: selectCharacters(item, networkId),
        Reason: reason,
        Valid: error ? (
          <CloseLineIcon color="#e74c3c" />
        ) : (
          <CheckLineIcon color="#2ecc71" />
        ),
        Status: error ? 0 : 1,
      };
    });
    setPreviewData(dataSource);
    setApiCall(true);

    let requestData = dataArr.map((item) => {
      let error = false;
      let reason = "";

      if (
        simType == 25 &&
        !validateSNo(selectCharacters(item, networkId), networkId, simType)
      ) {
        reason = "Invalid Serial Number";
        setCsvError(true);
        error = true;
      }
      return {
        fname: isIspWholeSaleNetwork ? "Robert" : "John",
        lname: isIspWholeSaleNetwork ? "Roy" : "Doe",
        simNumber: selectCharacters(item, networkId),
        status: error ? 0 : 1,
        reason,
      };
    });
    setActivationRequests(requestData);
  };
  return (
    <CardLayout title="Add Single Bulk Activation">
      {isUTel && utelError && (
        <div
          className="alert alert-danger mt-2"
          role="alert"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{utelError}</span>
          <button
            type="button"
            aria-label="Close"
            onClick={() => setUtelError("")}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "20px",
              lineHeight: "1",
              cursor: "pointer",
              color: "inherit",
            }}
          >
            &times;
          </button>
        </div>
      )}
      <div className="row mb-3">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            onClick={() => downloadSampleFile()}
            style={{
              background: "#2ecc71",
              color: "#fff",
              pointerEvents: "auto",
            }}
            className={`btn font-weight-bold mr-2`}
          >
            <DownloadCloud2sLineIcon size={16} />
            Sample File
          </button>
          <button
            type="button"
            onClick={() => back()}
            className={`btn btn-danger font-weight-bold`}
          >
            <ArrowLeftLineIcon size={16} />
            Back
          </button>
        </div>
        {/* <div className='col-lg-12 text-right'>{simTypeError}</div> */}
      </div>

      <div className="container">
        <form onSubmit={bulkActivationHandleSubmit(handleAddBulkActivation)}>
          {/* FORM FIELDS STARTS FROM HERE */}
          <div className="form-row">
            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Network <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Network"
                name="networkID"
                {...bulkActivationRegister("networkID", {
                  required: "Network is Required",
                })}
                onChange={(e) => {
                  handleNetwork(e);
                }}
              >
                <option value="" key="0" disabled>
                  Select
                </option>
                {networkResult.length > 0 &&
                  networkResult.map((network) => (
                    <option name="network" value={network.ID} key={network.ID}>
                      {network.NetworkName}
                    </option>
                  ))}
              </select>
              {bulkActivationError && bulkActivationError.networkID && (
                <div className="invalid-feedback">
                  {bulkActivationError.networkID.message}
                </div>
              )}
            </div>

            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Plan <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                placeholder="Select Plan"
                name="planID"
                {...bulkActivationRegister("planID", {
                  required: "Plan is Required",
                })}
                onChange={(e) => handleSelectPlan(e)}
              >
                <option value="" disabled key="0">
                  Select
                </option>
                {selectedPlan &&
                  selectedPlan.length > 0 &&
                  selectedPlan.map((plan) => (
                    <option name="plan" value={plan.PlanID} key={plan.PlanID}>
                      {" "}
                      {isIspWholeSaleNetwork
                        ? plan.PlanName
                        : `$${plan.PlanRentalPrice} - ${plan.PlanName}`}
                    </option>
                  ))}
              </select>
              {bulkActivationError && bulkActivationError.planID && (
                <div className="invalid-feedback">
                  {bulkActivationError.planID.message}
                </div>
              )}
            </div>

            {!isIspWholeSaleNetwork && (
              <>
                {!linkUpMobile && networkId != 15 && (
                  <div className="col-md-3 mb-3">
                    <label className="ml-2">
                      {" "}
                      <span className="text-danger"></span> Addon Service{" "}
                    </label>
                    <Controller
                      control={bulkActivationcontrol}
                      defaultValue={selectOptions.map((c) => c.value)}
                      name="serviceID"
                      render={({ field: { onChange, value, ref } }) => (
                        <ReactSelect
                          className="basic-multi-select"
                          placeholder="Select Service"
                          value={selectOptions.filter((c) =>
                            value.includes(c.value),
                          )}
                          onChange={(e) => handleSelectAddon(e)}
                          options={selectOptions}
                          isOptionDisabled={() =>
                            !addOnSelectMultiple &&
                            selectedAddon &&
                            selectedAddon.length >= 1
                          }
                          isMulti
                        />
                      )}
                    />
                    {bulkActivationError && bulkActivationError.serviceID && (
                      <div className="invalid-feedback">
                        {bulkActivationError.serviceID.message}
                      </div>
                    )}
                  </div>
                )}
                {networkId != 15 && (
                  <div className="col-md-3 mb-3">
                    <label className="ml-2">
                      Pin <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Pin"
                      disabled={networkId == 0}
                      className="form-control"
                      name="Pin"
                      {...bulkActivationRegister("Pin", {
                        required: "Pin Required",
                        validate: (val) => {
                          return validatePin(val, networkId) === true
                            ? true
                            : networkId == 1 || networkId == 2 || networkId == 5
                              ? "Six digit required"
                              : networkId == 3 ||
                                  networkId == 4 ||
                                  networkId == 7
                                ? "Four digit required"
                                : "Invalid pin";
                        },
                      })}
                    />
                    {bulkActivationError && bulkActivationError.Pin && (
                      <div className="invalid-feedback">
                        {bulkActivationError.Pin.message}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            <div className="col-md-3 mb-3">
              <label className="ml-2">
                {" "}
                Month <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                name="month"
                {...bulkActivationRegister("month", {
                  required: "Month is required !",
                })}
              >
                <option value="" key={`month`} disabled>
                  Select
                </option>
                {[...monthList]
                  .sort((a, b) => a.month - b.month)
                  .map((item, index) => {
                    return (
                      <option value={item.month} key={`month${index}`}>
                        {" "}
                        {item.month}{" "}
                      </option>
                    );
                  })}
              </select>
              {bulkActivationError && bulkActivationError.month && (
                <div className="invalid-feedback">
                  {bulkActivationError.month.message}
                </div>
              )}
            </div>

            {!isIspWholeSaleNetwork && (
              <div className="col-md-3 mb-3">
                <label className="ml-2">
                  State <span className="text-danger"> *</span>
                </label>
                <select
                  className="form-control"
                  name="state"
                  {...bulkActivationRegister("state", {
                    required: "State is required !",
                  })}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {stateOptions.length > 0 &&
                    stateOptions.map((item, index) => (
                      <option value={item} key={`address${index}`}>
                        {item}
                      </option>
                    ))}
                </select>
                {bulkActivationError && bulkActivationError.state && (
                  <div className="invalid-feedback">
                    {bulkActivationError.state.message}
                  </div>
                )}
              </div>
            )}

            <div className="col-md-3 mb-3">
              <label className="ml-2">
                SIM Type <span className="text-danger"> *</span>
              </label>
              <select
                className="form-control"
                name="simType"
                {...bulkActivationRegister("simType", {
                  required: "Sim type is required !",
                })}
              >
                <option value="" disabled>
                  Select
                </option>
                {shortCodeSimType &&
                  shortCodeSimType.length > 0 &&
                  shortCodeSimType.map((item) => {
                    return (
                      <option
                        value={item.ID}
                        disabled={
                          (item.ID == 26 && networkId == 7) ||
                          (isIspWholeSaleNetwork && item.ID == 26)
                        }
                        key={`simType${item.ID}`}
                      >
                        {item.Value}
                      </option>
                    );
                  })}
              </select>
              {bulkActivationError && bulkActivationError.simType && (
                <div className="invalid-feedback">
                  {bulkActivationError.simType.message}
                </div>
              )}
            </div>

            {linkUpMobile && (
              <div className="col-md-3 mb-3">
                <label className="ml-2">
                  Area Code <span className="text-danger"> *</span>
                </label>
                <input
                  type="Number"
                  placeholder="Enter Area Code"
                  className="form-control"
                  name="threeDigAreaCode"
                  {...bulkActivationRegister("threeDigAreaCode", {
                    required: "Area Code Required",
                    pattern: {
                      value: /^[0-9]{3}$/,
                      message: "Only 3 digit area code allowed",
                    },
                  })}
                />
                {bulkActivationError &&
                  bulkActivationError.threeDigAreaCode && (
                    <div className="invalid-feedback">
                      {bulkActivationError.threeDigAreaCode.message}
                    </div>
                  )}
              </div>
            )}

            {prefferAggId != 0 &&
            (simType == 25 || simType == 26) &&
            !isIspWholeSaleNetwork ? (
              <div className="col-md-6 mb-3 p-0">
                <div className="input-group">
                  <label htmlFor="csvFile">
                    <span className="text-danger">*</span>Upload File{" "}
                  </label>
                  <input
                    type="file"
                    className="form-control-file"
                    name="uploadedFile"
                    id="csvFile"
                    accept=".csv"
                    {...bulkActivationRegister("uploadedFile", {
                      required: "Csv is required",
                    })}
                    onChange={(e) => handleFileChange(e)}
                  />
                  <small className="text-danger">{`Note : Only ${ACTIVATION_LIMIT} Rows are allowed`}</small>
                  {bulkActivationError && bulkActivationError.uploadedFile && (
                    <div className="invalid-feedback">
                      {bulkActivationError.uploadedFile.message}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {isIspWholeSaleNetwork && simType == 25 && (
              <div className="col-md-6 mb-3 p-0">
                <div className="col-md-6 mb-3 p-0">
                  <label htmlFor="data">
                    Data<span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    id="data"
                    rows="5"
                    style={{ resize: "none" }}
                    onChange={(e) => handleTextareaChange(e.target.value)}
                  ></textarea>
                  {bulkActivationError && bulkActivationError.uploadedFile && (
                    <div className="invalid-feedback">
                      {bulkActivationError.uploadedFile.message}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {/* FORM FIELDS END HERE */}

          {previewData.length > 0 && (
            <>
              <hr />
              <div className="row p-0 m-0" style={{ cursor: "pointer" }}>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center py-3 preview-box"
                  onClick={() => {
                    handlePreviewTableData(2);
                  }}
                >
                  <h4>Total Submitted : {previewData.length}</h4>
                </div>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                  onClick={() => {
                    handlePreviewTableData(1);
                  }}
                >
                  <h4 className="text-success">
                    Valid : {previewSuccessCount}
                  </h4>
                </div>
                <div
                  className="col-md-4 d-flex justify-content-around align-items-center preview-box"
                  onClick={() => {
                    handlePreviewTableData(0);
                  }}
                >
                  <h4 className="text-danger">
                    Invalid : {previewData.length - previewSuccessCount}
                  </h4>
                </div>
              </div>
              <div className="col-md-12 mb-3 p-0">
                <Table
                  columns={previewColumns}
                  loading={validateSerialNumberLoading}
                  data={
                    showPreviewType == 1
                      ? previewSuccessData
                      : showPreviewType == 0
                        ? previewFailedData
                        : previewData
                  }
                  pagination={false}
                />
              </div>

              <div className="col-md-12 mb-3 p-0">
                <h4>Price details</h4>
                <Table
                  columns={estimatedAmountColumn}
                  loading={false}
                  data={estimatedAmountDataSource}
                  pagination={false}
                />
              </div>
            </>
          )}
          <hr />

          {showAlert && (
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          )}

          <div className="text-right row">
            <div className="col-md-12">
              {prefferAggId == null || prefferAggId == undefined ? (
                <span className="text-danger mr-2 font-weight-bold">
                  Configuration not set, please contact admin
                </span>
              ) : (
                ""
              )}
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => back()}
              >
                Close
              </button>
              {activationRequests.filter((item) => item.status === 1).length >
                0 && validateSerialNumberLoading === false ? (
                <Button
                  title="Submit"
                  style="minWidth:80px"
                  loading={addBulkActivationLoading}
                  buttonClass="btn btn-primary"
                  buttonType="submit"
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </form>
      </div>
    </CardLayout>
  );
};

export default BulkActivationForm;
